import { defineComponent as g, mergeModels as c, useModel as h, getCurrentInstance as C, inject as V, useTemplateRef as k, createElementBlock as r, openBlock as i, mergeProps as I, unref as o, renderSlot as v, createElementVNode as x, normalizeClass as l, createCommentVNode as y, withDirectives as $, vModelDynamic as B } from "vue";
import s from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/TextInputGroup/text-input-group.js";
import { useChildrenTracker as P } from "../../use/children-tracker.js";
import { TextInputGroupDisabledKey as S } from "./TextInputGroup.vue2.js";
import { useOUIAProps as D } from "../../helpers/ouia.js";
import { FormInputsKey as R } from "../Form/common.js";
const A = ["value"], E = ["disabled"], z = /* @__PURE__ */ g({
  name: "PfTextInputGroupMain",
  inheritAttrs: !1,
  __name: "TextInputGroupMain",
  props: /* @__PURE__ */ c({
    hint: {},
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  }, {
    modelValue: { default: null },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ c(["change", "focus", "blur"], ["update:modelValue"]),
  setup(a, { expose: G, emit: T }) {
    var f;
    const p = a, b = D({ id: p.ouiaId, safe: p.ouiaSafe }), d = h(a, "modelValue"), u = T;
    P(R, (f = C()) == null ? void 0 : f.proxy);
    const M = V(S, !1), m = k("inputRef");
    return G({
      input: m,
      focus(t) {
        var e;
        (e = m.value) == null || e.focus(t);
      }
    }), (t, e) => (i(), r("div", I(o(b), {
      class: [o(s).textInputGroupMain, {
        [o(s).modifiers.icon]: !!t.$slots.icon
      }]
    }), [
      v(t.$slots, "default"),
      x("span", {
        class: l(o(s).textInputGroupText)
      }, [
        t.hint ? (i(), r("input", {
          key: 0,
          class: l([o(s).textInputGroupTextInput, o(s).modifiers.hint]),
          type: "text",
          disabled: "",
          "aria-hidden": "true",
          value: t.hint
        }, null, 10, A)) : y("", !0),
        t.$slots.icon ? (i(), r("span", {
          key: 1,
          class: l(o(s).textInputGroupIcon)
        }, [
          v(t.$slots, "icon")
        ], 2)) : y("", !0),
        $(x("input", I({ ref: "inputRef" }, t.$attrs, {
          "onUpdate:modelValue": e[0] || (e[0] = (n) => d.value = n),
          class: o(s).textInputGroupTextInput,
          disabled: o(M) || void 0,
          onChange: e[1] || (e[1] = (n) => u("change", n)),
          onFocus: e[2] || (e[2] = (n) => u("focus", n)),
          onBlur: e[3] || (e[3] = (n) => u("blur", n))
        }), null, 16, E), [
          [B, d.value]
        ])
      ], 2)
    ], 16));
  }
});
export {
  z as default
};
